// copied some code from https://codesandbox.io/s/y3qzyr3lrz?file=/src/use-multi-key-press.js
import { useEffect, useState } from "react";

function areKeysPressed(keys: string[], keysPressed: Set<string>) {
  const requiredKeys = new Set(keys);

  keysPressed.forEach(key => {
    requiredKeys.delete(key);
  });

  return requiredKeys.size === 0;
}

export const useMultiKeyPress = (
  requiredKeys: string[],
  handleMultipleKeyPressed: () => void,
) => {
  const [keysPressed, setKeyPressed] = useState(new Set<string>([]));

  function downHandler({ key }: KeyboardEvent) {
    setKeyPressed(keysPressed.add(key));
  }

  const upHandler = ({ key }: KeyboardEvent) => {
    keysPressed.delete(key);
    setKeyPressed(keysPressed);
  };

  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);

    if (areKeysPressed(requiredKeys, keysPressed)) handleMultipleKeyPressed();

    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  }, [handleMultipleKeyPressed]);
};
